import React, {useCallback, useEffect, useState} from "react";
import {useIdleTimer} from "react-idle-timer";
import {useDispatch, useSelector} from "react-redux";
import {
  clearRoomProfiles, selectSession,
  updatePayerProfile, updateReservation
} from "../booknow/session/sessionSlice";
import IdleTimeDialog from "./IdleTimeDialog";
import {logoutAgent, selectApp} from "../booknow/app/appSlice";
import {doLogoutSSO, getApiUrl, SINGLE_SIGN_OUT} from "../api/client";
import Cookies from "js-cookie";
import {isStatus, removeReservation} from "../booknow/session/reservationUtil";
import ReservationStatuses from "../booknow/session/reservationStatuses";

const timeout = (20000 * 60)
const promptBeforeIdle = 60000
export default function IdleTimer() {

  const customer = useSelector(state => selectApp(state).customer);
  const agent = useSelector(state => selectApp(state).agent);
  const reservation = useSelector(state => selectSession(state).reservation);

  const [remaining, setRemaining] = useState(timeout)
  const [open, setOpen] = useState(false)
  const [detailsCleared, setDetailsCleared] = useState(false)

  const onIdle = () => {
    // setOpen(false)
    setDetailsCleared(true)

    updatePayerProfile_({
      title: 'Mr',
      titleId: 1,
      countryId: 197, // defaults
    })

    clearRoomProfiles_()

    if(agent) {
      logoutAgent_()

      if(reservation) {
        removeReservation().then(
            updateReservation_(undefined)
        )
      }

      doLogoutSSO(getApiUrl(customer, SINGLE_SIGN_OUT)).then(() => {
        Cookies.remove('hti-session')
      })
    }
  }

  const onActive = () => {
    // setOpen(false)
  }

  const onPrompt = () => {
    setDetailsCleared(false)
    setOpen(true)
  }

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000))
    }, 500)

    return () => {
      clearInterval(interval)
    }
  })

  const handleStillHere = () => {
    setOpen(false)
    activate()
  }

  const dispatch = useDispatch();
  const updatePayerProfile_ = React.useCallback((payerProfile) => dispatch(updatePayerProfile({payerProfile})), [dispatch]);
  const clearRoomProfiles_ = React.useCallback(() => dispatch(clearRoomProfiles()), [dispatch]);
  const logoutAgent_ = React.useCallback(() => dispatch(logoutAgent()), [dispatch]);
  const updateReservation_ = useCallback((reservation) => dispatch(updateReservation({reservation})), [dispatch]);

  return (
    <IdleTimeDialog open={open}
                    setOpen={setOpen}
                    onIdle={onIdle}
                    handleStillHere={handleStillHere}
                    detailsCleared={detailsCleared}
                    remaining={remaining} />
  )
}